/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-sla': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#e77474"><path pid="0" d="M9.988 19.808c5.39 0 9.759-4.37 9.759-9.76S15.377.29 9.987.29.229 4.66.229 10.05s4.37 9.759 9.76 9.759zm0-1a8.76 8.76 0 1 1 0-17.519 8.76 8.76 0 0 1 0 17.519z"/><path pid="1" d="M10.429 2.715V.835a.45.45 0 0 0-.9 0v1.88a.45.45 0 1 0 .9 0zM.75 10.449h1.88a.45.45 0 1 0 0-.9H.75a.45.45 0 0 0 0 .9zM17.418 10.449h1.879a.45.45 0 1 0 0-.9h-1.88a.45.45 0 1 0 0 .9zM10.93 10.235l3.085-3.929a.45.45 0 1 0-.707-.556l-3.086 3.93a.45.45 0 0 0 .707.555z"/><path pid="2" d="M11.603 12.835a2.538 2.538 0 0 1-3.372 1.161 2.49 2.49 0 0 1-1.154-3.351 2.538 2.538 0 0 1 3.372-1.161 2.49 2.49 0 0 1 1.154 3.351zm-1.544-2.54a1.638 1.638 0 0 0-2.175.748 1.59 1.59 0 0 0 .738 2.143 1.638 1.638 0 0 0 2.174-.749 1.59 1.59 0 0 0-.737-2.143z"/></g>'
  }
})
